/**
 * Step registry — maps step `kind` to its renderer. Every step component
 * accepts {@link StepRenderProps}.
 *
 * Adding a new step kind:
 *   1. extend `ConnectorStepKind` in `../ConnectorWizardModal.types.ts`
 *   2. create a renderer that consumes `StepRenderProps`
 *   3. register it here.
 */

import React from "react";
import type { FC } from "react";
import type {
  ConnectorStepKind,
  StepRenderProps,
} from "../ConnectorWizardModal.types";
import { CredentialsStep } from "./CredentialsStep";
import { TestStep } from "./TestStep";
import { SelectStep } from "./SelectStep";
import { BiSelectStep } from "./BiSelectStep";
import { PreviewStep } from "./PreviewStep";
import { FinishStep } from "./FinishStep";
import { PlaceholderStep } from "./PlaceholderStep";

const SelectStepRouter: FC<StepRenderProps> = (props) => {
  if (props.wizardConfig.behavior?.uiVariant === "bi_relational_tree") {
    return React.createElement(BiSelectStep, props);
  }
  return React.createElement(SelectStep, props);
};

export const STEP_REGISTRY: Record<ConnectorStepKind, FC<StepRenderProps>> = {
  credentials: CredentialsStep,
  test: TestStep,
  select: SelectStepRouter,
  preview: PreviewStep,
  finish: FinishStep,
};

export {
  CredentialsStep,
  TestStep,
  SelectStep,
  BiSelectStep,
  PreviewStep,
  FinishStep,
  PlaceholderStep,
};
